import { createIdentifier } from '@blocksuite/global/di';
import type { ReadonlySignal } from '@preact/signals-core';

export type DataViewSearchUiState = {
  expanded: boolean;
  /**
   * Live input text, published on every keystroke for Canvas collaborators.
   * `query` remains the debounced value used by the potentially expensive
   * database filter projection.
   */
  input?: string;
  query: string;
};

export interface DataViewSearchCollaboration {
  readonly states$: ReadonlySignal<
    Readonly<Record<string, DataViewSearchUiState>>
  >;
  update(viewId: string, state: DataViewSearchUiState): void;
}

export const DataViewSearchCollaboration =
  createIdentifier<DataViewSearchCollaboration>(
    'data-view-search-collaboration'
  );
